import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ColorPickerValidator } from '../../validators/color-picker-validator.directive';

@Component({
    selector: 'color-picker',
    templateUrl: 'color-picker.component.html',
    styleUrls: ['color-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ColorPickerComponent implements OnInit {
  @Input() hexColor: string;
  @Input() title: string;
  @Input() showColorPicker: boolean;

  @Input() controlName: string;
  @Input() showColorPickerControlName: string;

  @Input() parentFormGroup: FormGroup;

  constructor(private readonly fb: FormBuilder) { }

  ngOnInit(): void {
    this.addControls();
  }

  onHexColorBlur(): void {
    this.addPrefix();
  }

  onColorPickerInput(event: Event): void {
    const color = (event.target as HTMLInputElement).value;
    this.parentFormGroup.controls[this.controlName].setValue(color);
  }

  get colorValue(): string {
    return this.parentFormGroup?.controls[this.controlName]?.value ?? '#000000';
  }

  showColorPickerChecked($event: MatCheckboxChange): void {
    this.showColorPicker = $event.checked;
  }

  private addControls(): void {    
    this.parentFormGroup.addControl(this.controlName, this.fb.control(this.hexColor));
    this.parentFormGroup.addControl(this.showColorPickerControlName, this.fb.control(this.showColorPicker));

    const validator = new ColorPickerValidator();
    this.parentFormGroup.addValidators(validator.validate(this.controlName, this.showColorPickerControlName));
    this.parentFormGroup.updateValueAndValidity({ emitEvent: false });
  }

  private addPrefix(): void {
    const colorControl = this.parentFormGroup.controls[this.controlName];
    const color = colorControl.value as string;
    if (color?.length && !color.startsWith('#')) {
      colorControl.setValue('#' + color);
    }
  }
}
